import { useCallback, useEffect, useMemo, useState } from "react";

export function nextHiddenSeriesMap(prev, seriesName, seriesNames) {
  const nextHidden = !prev[seriesName];
  const wouldHideAll =
    nextHidden &&
    seriesNames.every((name) => (name === seriesName ? true : prev[name]));
  if (wouldHideAll) return prev;
  return { ...prev, [seriesName]: nextHidden };
}

export function useChartSeriesVisibility(seriesNames = [], resetKey = "") {
  const [hiddenSeries, setHiddenSeries] = useState({});
  const visibilityKey = `${resetKey}\0${seriesNames.join("\0")}`;

  useEffect(() => {
    setHiddenSeries({});
  }, [visibilityKey]);

  const visibleSeries = useMemo(
    () => seriesNames.filter((name) => !hiddenSeries[name]),
    [seriesNames, hiddenSeries],
  );

  const toggleSeries = useCallback(
    (seriesName) => {
      setHiddenSeries((prev) =>
        nextHiddenSeriesMap(prev, seriesName, seriesNames),
      );
    },
    [seriesNames],
  );

  return { hiddenSeries, visibleSeries, toggleSeries };
}
